import { cn } from '@mriqbox/ui-kit'
import { UPLOAD_LIMITS, UPLOAD_LIMIT_ORDER, type UploadLimit } from '@/lib/uploadLimit'

export interface UploadLimitMenuProps {
    value: UploadLimit
    onChange: (limit: UploadLimit) => void
    headingClassName: string
}

/** Same section in both quality menus. */
export function UploadLimitMenu({ value, onChange, headingClassName }: UploadLimitMenuProps) {
    return (
        <>
            <p className={headingClassName}>Limite de upload</p>
            {UPLOAD_LIMIT_ORDER.map((key) => (
                <button
                    key={key}
                    type="button"
                    onClick={() => onChange(key)}
                    aria-pressed={value === key}
                    className={cn(
                        'w-full rounded-lg px-2 py-1.5 text-left transition-colors hover:bg-accent',
                        value === key && 'bg-accent'
                    )}
                >
                    <span className="block text-sm font-medium text-foreground">{UPLOAD_LIMITS[key].label}</span>
                    <span className="block text-[11px] text-muted-foreground">{UPLOAD_LIMITS[key].description}</span>
                </button>
            ))}
        </>
    )
}
